// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__2m7MJ","choiceBoxes":"toolbarselects_choiceBoxes__1TfPJ","simpleField":"toolbarselects_simpleField__3IWUO"};